// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  width: 100%;
  height: 100vh;
  background-color: #f8fafc;
  font-family: "Inter", sans-serif;
}

.dashboard-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.main-content {
  flex: 1 1;
  padding: 1.5rem;
  overflow-y: auto;
}

.welcome-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);
  color: white;
  border-radius: 1rem;
  padding: 1.25rem 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.5);
  animation: slideInUp 0.5s ease-out;
}

.welcome-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.welcome-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 0.75rem;
  flex-shrink: 0;
}

.welcome-text h3 {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.25rem;
}

.welcome-text p {
  font-size: 0.875rem;
  margin: 0;
  opacity: 0.9;
}

.welcome-close {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.welcome-close:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.dashboard-header {
  display: flex;
  /* justify-content: end; */
  align-items: center;
  /* margin-bottom: 2rem; */
}

.dashboard-title h1 {
  font-size: 1.875rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.5rem;
  letter-spacing: -0.025em;
}

.dashboard-title p {
  font-size: 1rem;
  color: #64748b;
  max-width: 500px;
}

.dashboard-actions {
  display: flex;
  gap: 1rem;
}

.action-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.action-button.primary {
  background-color: #3b82f6;
  color: white;
}

.action-button.primary:hover {
  background-color: #2563eb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.action-button.secondary {
  background-color: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.action-button.secondary:hover {
  background-color: #e2e8f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.action-icon {
  font-size: 1.25rem;
  line-height: 1;
}

.statistics-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.section-header h2 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.section-controls {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.filter-dropdown {
  position: relative;
}

.filter-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
}

.filter-button:hover {
  background-color: #e2e8f0;
}

.dropdown-arrow {
  transform: rotate(90deg);
  transition: transform 0.2s;
}

.export-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  background-color: #f1f5f9;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
}

.export-button:hover {
  background-color: #e2e8f0;
}

.view-options {
  display: flex;
  background-color: #f1f5f9;
  border-radius: 0.5rem;
  padding: 0.25rem;
}

.view-option {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.view-option.active {
  background-color: white;
  color: #1e293b;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.sections-container {
  transition: all 0.3s ease;
}

.sections-container.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.75rem;
}

.sections-container.list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 40;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  backdrop-filter: blur(4px);
}

.sidebar-overlay.active {
  opacity: 1;
  pointer-events: auto;
}

@media (max-width: 1536px) {
  .statistics-row {
    grid-template-columns: repeat(4, 1fr);
  }

  .sections-container.grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  }
}

@media (max-width: 1280px) {
  .statistics-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .sections-container.grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  }
}

@media (max-width: 1024px) {
  .sections-container.grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  .section-controls {
    gap: 0.5rem;
  }

  .filter-button span,
  .export-button span {
    display: none;
  }

  .filter-button,
  .export-button {
    padding: 0.5rem;
  }
}

@media (max-width: 768px) {
  .dashboard-header {
    /* flex-direction: column; */
    /* align-items: flex-start; */
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .dashboard-actions {
    width: 100%;
  }

  .statistics-row {
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }

  .sections-container.grid {
    grid-template-columns: 1fr 1fr;
  }

  .main-content {
    padding: 1.5rem;
  }

  .dashboard-title h1 {
    font-size: 1.5rem;
  }

  .welcome-banner {
    padding: 1rem;
  }

  .welcome-icon {
    width: 2.5rem;
    height: 2.5rem;
  }
}

@media (max-width: 640px) {
  .action-button {
    flex: 1 1;
    justify-content: center;
  }

  .main-content {
    padding: 1.25rem;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .section-controls {
    width: 100%;
    justify-content: space-between;
  }
}
@media (max-width: 426px) {
  .sections-container.grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,SAAO;IACP,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".dashboard {\n  display: flex;\n  width: 100%;\n  height: 100vh;\n  background-color: #f8fafc;\n  font-family: \"Inter\", sans-serif;\n}\n\n.dashboard-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.main-content {\n  flex: 1;\n  padding: 1.5rem;\n  overflow-y: auto;\n}\n\n.welcome-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%);\n  color: white;\n  border-radius: 1rem;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 10px 25px -5px rgba(59, 130, 246, 0.5);\n  animation: slideInUp 0.5s ease-out;\n}\n\n.welcome-content {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.welcome-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 0.75rem;\n  flex-shrink: 0;\n}\n\n.welcome-text h3 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin: 0 0 0.25rem;\n}\n\n.welcome-text p {\n  font-size: 0.875rem;\n  margin: 0;\n  opacity: 0.9;\n}\n\n.welcome-close {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 1.5rem;\n  cursor: pointer;\n  width: 2rem;\n  height: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.welcome-close:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.dashboard-header {\n  display: flex;\n  /* justify-content: end; */\n  align-items: center;\n  /* margin-bottom: 2rem; */\n}\n\n.dashboard-title h1 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #1e293b;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.025em;\n}\n\n.dashboard-title p {\n  font-size: 1rem;\n  color: #64748b;\n  max-width: 500px;\n}\n\n.dashboard-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.action-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.action-button.primary {\n  background-color: #3b82f6;\n  color: white;\n}\n\n.action-button.primary:hover {\n  background-color: #2563eb;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.action-button.secondary {\n  background-color: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n}\n\n.action-button.secondary:hover {\n  background-color: #e2e8f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.action-icon {\n  font-size: 1.25rem;\n  line-height: 1;\n}\n\n.statistics-row {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.section-header h2 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.section-controls {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.filter-dropdown {\n  position: relative;\n}\n\n.filter-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #475569;\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.filter-button:hover {\n  background-color: #e2e8f0;\n}\n\n.dropdown-arrow {\n  transform: rotate(90deg);\n  transition: transform 0.2s;\n}\n\n.export-button {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #475569;\n  background-color: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.export-button:hover {\n  background-color: #e2e8f0;\n}\n\n.view-options {\n  display: flex;\n  background-color: #f1f5f9;\n  border-radius: 0.5rem;\n  padding: 0.25rem;\n}\n\n.view-option {\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.view-option.active {\n  background-color: white;\n  color: #1e293b;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.sections-container {\n  transition: all 0.3s ease;\n}\n\n.sections-container.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.75rem;\n}\n\n.sections-container.list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.sidebar-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 40;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  backdrop-filter: blur(4px);\n}\n\n.sidebar-overlay.active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n@media (max-width: 1536px) {\n  .statistics-row {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n  .sections-container.grid {\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  }\n}\n\n@media (max-width: 1280px) {\n  .statistics-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .sections-container.grid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  }\n}\n\n@media (max-width: 1024px) {\n  .sections-container.grid {\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  }\n\n  .section-controls {\n    gap: 0.5rem;\n  }\n\n  .filter-button span,\n  .export-button span {\n    display: none;\n  }\n\n  .filter-button,\n  .export-button {\n    padding: 0.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .dashboard-header {\n    /* flex-direction: column; */\n    /* align-items: flex-start; */\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n  }\n\n  .dashboard-actions {\n    width: 100%;\n  }\n\n  .statistics-row {\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n  }\n\n  .sections-container.grid {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .main-content {\n    padding: 1.5rem;\n  }\n\n  .dashboard-title h1 {\n    font-size: 1.5rem;\n  }\n\n  .welcome-banner {\n    padding: 1rem;\n  }\n\n  .welcome-icon {\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n}\n\n@media (max-width: 640px) {\n  .action-button {\n    flex: 1;\n    justify-content: center;\n  }\n\n  .main-content {\n    padding: 1.25rem;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .section-controls {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n@media (max-width: 426px) {\n  .sections-container.grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
